import * as z from "zod";

const errorDetail = z.object({
  type: z.string().nullish(),
  code: z.union([z.string(), z.number()]).nullish(),
  message: z.string().nullish(),
});

const errorBody = errorDetail.extend({ error: errorDetail.nullish() });

function detailOf(payload: object): string | null {
  const parsed = errorBody.safeParse(payload);
  if (!parsed.success) return null;
  const { type, code, message, error: nested } = parsed.data;
  const detail = nested ?? { type, code, message };
  return (
    [detail.code, detail.message].filter(Boolean).join(": ") ||
    detail.type ||
    type ||
    null
  );
}

// The AI SDK's `error` stream part carries a real Error, the provider's raw
// JSON error body, or a bare string for the SDK's own stream invariants. Only
// the stream consumer can tell which is which, so it tags provider bodies with
// this class at the throw site and downstream code classifies by type alone.
export class ProviderStreamError extends Error {
  private constructor(readonly payload: object) {
    super(detailOf(payload) ?? "Unknown error");
    this.name = "ProviderStreamError";
  }

  static coerce(payload: unknown): unknown {
    if (typeof payload !== "object" || payload === null) return payload;
    if (payload instanceof Error) return payload;
    return new ProviderStreamError(payload);
  }
}
